import { Oval } from "react-loader-spinner";
import { NavigateFunction } from "react-router";
import { ToastOptions, toast } from "react-toastify";
import * as anchor from "@coral-xyz/anchor";

import checkIcon from "Assets/Svgs/checkIcon.svg";
import errorIcon from "Assets/Svgs/txReject.svg";
import warningIcon from "Assets/Svgs/warning.svg";

const commonToastConfig: Partial<ToastOptions> = {
  position: "bottom-right",
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "dark",
  bodyClassName: "info-toast-body",
};

class Cache {
  navigation: NavigateFunction = () => {};
  stakingProgramInstance: anchor.Program<anchor.Idl> | undefined = undefined;
  errorToast = (text: string | JSX.Element, options?: ToastOptions<{}>) =>
    toast.error(text, {
      ...commonToastConfig,
      bodyClassName: "",
      icon: ({ theme, type }) => (
        <img src={errorIcon} alt="checkIcon" style={{ marginTop: "3px" }} />
      ),
      style: {
        backgroundImage: "linear-gradient(139deg, rgb(0, 0, 0), 72%, rgba(240, 66, 72, 0.3))",
      },
      ...options,
    });

  TxProgressToast = (text: string | JSX.Element, options?: ToastOptions<{}>) =>
    toast.error(text, {
      ...commonToastConfig,
      icon: ({ theme, type }) => (
        <Oval
          color="#cd42ff"
          secondaryColor="rgba(255, 255, 255, 0.1)"
          strokeWidth={7}
          width={25}
          height={25}
          wrapperStyle={{ marginTop: "3px" }}
        />
      ),
      style: {
        backgroundImage: "linear-gradient(139deg, rgb(0, 0, 0), 72%, rgba(255, 210, 31, 0.3))",
      },
      autoClose: false,
      ...options,
    });

  warningToast = (text: string | JSX.Element, options?: ToastOptions<{}>) =>
    toast.warning(text, {
      ...commonToastConfig,
      icon: ({ theme, type }) => (
        <img src={warningIcon} alt="checkIcon" style={{ marginTop: "3px" }} />
      ),
      style: {
        backgroundImage: "linear-gradient(139deg, rgb(0, 0, 0), 72%, rgba(255, 210, 31, 0.3))",
      },
      ...options,
    });

  successToast = (text: string | JSX.Element, options?: ToastOptions<{}>) =>
    toast.success(text, {
      ...commonToastConfig,
      icon: ({ theme, type }) => (
        <img src={checkIcon} alt="checkIcon" style={{ marginTop: "3px" }} />
      ),
      style: {
        backgroundImage: "linear-gradient(139deg, rgb(0, 0, 0), 72%, rgba(0, 223, 128, 0.2))",
      },
      ...options,
    });
}

const CachedService = new Cache();

export default CachedService;
